import { render } from "./Demand.vue?vue&type=template&id=21a71d60&scoped=true"
import script from "./Demand.vue?vue&type=script&lang=js"
export * from "./Demand.vue?vue&type=script&lang=js"

import "./Demand.vue?vue&type=style&index=0&id=21a71d60&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a71d60"]])

export default __exports__